<template>
  <article class="notification" :class="'is-' + data.module">
    <b-tooltip
      :label="$t('compScenarioRule.tooltip-1')"
      type="is-black"
      class="rule-config"
    >
      <b-icon
        v-if="hasConfig"
        icon="filter"
        size="is-medium"
        type="is-info"
        @click.native="configModal = true"
        :class="'is-' + data.module"
      />
    </b-tooltip>
    <b-tooltip
      :label="$t('compScenarioRule.tooltip-2')"
      type="is-black"
      class="rule-remove"
    >
      <button
        type="button"
        @click="$emit('close', data)"
        class="delete"
      ></button>
    </b-tooltip>
    <div class="media">
      <div class="media-content">
        <label @click="displayRule()" class="label rule-label">
          {{ translate('title') }}
          <p class="sub-label">
            <span v-html="translate('level1help')" />
            <br v-if="this.data.hasLevel2Parameters" />
            <span
              v-if="this.data.hasLevel2Parameters"
              v-html="translate('level2label')"
            />
          </p>
        </label>
        <b-field>
          <b-slider
            v-model="value"
            lazy
            ref="slider"
            :min="data.level1Min"
            :max="data.level1Max"
            :step="data.level1Step"
            :custom-formatter="labelFormatter"
            @input="updateLevel1($event)"
            @dragging="stopUpdate($event)"
            @change="changeLevel1"
            :class="'is-' + data.module"
          >
            <b-slider-tick
              v-for="(tick, index) in ticks"
              :key="index"
              :value="tick.value"
            >
              <span> {{ tickFormatter(tick.display) }} </span>
            </b-slider-tick>
          </b-slider>
        </b-field>
        <rule-parameter-modal
          v-if="data.hasLevel2Parameters"
          :active="configModal"
          :rule="data"
          @update-level2="updateLevel2"
          @reset-level2="resetLevel2"
          @close="configModal = false"
        />
        <b-modal :active.sync="cardModal" has-modal-card :width="900">
          <div class="modal-card" style="width: 900px">
            <section class="modal-card-body">
              <rule-card :rule="data" :ghgi="ghgi" />
            </section>
          </div>
        </b-modal>
      </div>
    </div>
  </article>
</template>

<script>
import Rule from '../../models/scenario/Rule'

export default {
  name: 'Rule',
  props: {
    data: {
      type: Object,
      default: null
    },
    ghgi: {
      type: Object,
      default: null
    }
  },
  components: {
    'rule-card': () => import('@/components/scenario/RuleCard.vue'),
    'rule-parameter-modal': () =>
      import('@/components/scenario/RuleParameterModal.vue')
  },
  data () {
    return {
      value: this.data.level1,
      configModal: false,
      cardModal: false
    }
  },
  computed: {
    maxValue: function () {
      return this.data.level1MaxValue
    },
    hasConfig: function () {
      let hasConfig = false
      if (this.data.hasLevel2Parameters) {
        for (let param of Object.keys(this.data.level2)) {
          if (this.data.getLevel2Values(param).length > 1) {
            hasConfig = true
          }
        }
      }
      return hasConfig
    },
    ticks: function () {
      /* let ticks = []
      for (let tick of this.data.level1Ticks) {
        let displayValue = this.$t('compScenarioRule.' + tick.display.toString())
        if ('tickslimit' in this.data.level1) {
          displayValue = displayValue.substring(0, this.data.level1.tickslimit)
        }
        ticks.push({
          value: tick.value,
          display: displayValue
        })
      }
      return ticks */
      return this.data.level1Ticks
    }
  },
  methods: {
    displayRule () {
      this.cardModal = true
    },
    labelFormatter (val) {
      let nval = val
      if (val !== 0) {
        nval = this.$t(val)
      }
      return this.$t(this.data.labelFormatter(nval))
    },
    tickFormatter (val) {
      let nval = val
      if (val !== 0) {
        nval = this.$t(val)
      }
      if (this.data.tickslimit) {
        return this.data.tickFormatter(nval).substring(0, this.data.tickslimit)
      } else {
        return this.data.tickFormatter(nval)
      }
    },
    translate (key) {
      let translation = Rule.translate(this.data, key, this.$i18n.locale)
      if (this.data.hasLevel2Parameters) {
        for (let l2key of Object.keys(this.data.level2)) {
          if (translation.includes('__' + l2key + '__')) {
            if (this.data.allValuesSelected(l2key)) {
              let allValue = Rule.translate(this.data, 'all', this.$i18n.locale)
              translation = translation.replace('__' + l2key + '__', allValue)
            } else {
              let tlist = ''
              const NDISPLAY = 3
              for (let item of this.data.level2[l2key].value.slice(
                0,
                NDISPLAY
              )) {
                tlist +=
                  this.$options.filters.truncate(this.$t(item), 10) + ', '
              }
              tlist = tlist.substring(0, tlist.length - 2)
              let nmore = this.data.level2[l2key].value.length - NDISPLAY
              if (nmore > 0) {
                tlist +=
                  ' ' +
                  this.$t('compScenarioRule.and') +
                  ' ' +
                  nmore +
                  ' ' +
                  this.$t('compScenarioRule.more')
              }
              translation = translation.replace('__' + l2key + '__', tlist)
            }
          }
        }
      }
      return translation
    },
    updateLevel1 (val) {
      this.value = Math.min(this.maxValue, val)
      this.stopUpdate(val)
      this.$emit('update-level1', {
        id: this.data.id,
        module: this.data.module,
        value: this.value
      })
    },
    stopUpdate (val) {
      if (val > this.maxValue) {
        this.$refs.slider.value1 = this.maxValue
      }
    },
    changeLevel1 () {
      this.$emit('change-level1', {
        id: this.data.id,
        module: this.data.module,
        value: this.value
      })
    },
    updateLevel2 (data) {
      this.$emit('update-level2', {
        id: data.id,
        module: data.module,
        values: data.values
      })
      this.configModal = false
    },
    resetLevel2 (data) {
      this.configModal = false
      this.$emit('reset-level2', {
        id: data.id,
        module: data.module
      })
    }
  }
}
</script>

<style scoped>
.sub-label {
  font-size: 0.7rem;
  font-weight: 400;
}
nav.level {
  margin-bottom: 0;
}
span.icon {
  cursor: pointer;
}
.notification > .rule-config {
  right: 30px;
  position: absolute;
  top: 2px;
}
.notification > .rule-remove {
  right: 8px;
  position: absolute;
  top: 8px;
}
.rule-label {
  cursor: pointer;
}
</style>

<style>
.b-slider.is-heatings .b-slider-fill {
  background: #c84896 !important;
}
.has-text-info.is-heatings {
  color: #c84896 !important;
}
.b-slider.is-heatings .b-tooltip.is-primary .tooltip-content {
  background: #c84896;
}
.b-slider.is-heatings .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #c84896 !important;
}
.switch.is-heatings input[type='checkbox']:checked + .check {
  background: #c84896 !important;
}
.switch.is-heatings input[type='checkbox']:focus:checked + .check {
  -webkit-box-shadow: 0 0 0.5em rgba(200, 72, 150, 0.8) !important;
  box-shadow: 0 0 0.5em rgba(200, 72, 150, 0.8) !important;
}

.b-slider.is-electricity .b-slider-fill {
  background: #e88bc3 !important;
}
.has-text-info.is-electricity {
  color: #e88bc3 !important;
}
.b-slider.is-electricity .b-tooltip.is-primary .tooltip-content {
  background: #e88bc3;
}
.b-slider.is-electricity .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #e88bc3 !important;
}
.switch.is-electricity input[type='checkbox']:checked + .check {
  background: #e88bc3 !important;
}
.switch.is-electricity input[type='checkbox']:focus:checked + .check {
  -webkit-box-shadow: 0 0 0.5em rgba(232, 139, 195, 0.8) !important;
  box-shadow: 0 0 0.5em rgba(232, 139, 195, 0.8) !important;
}

.b-slider.is-refrigerants .b-slider-fill {
  background: #fdc2e5 !important;
}
.has-text-info.is-refrigerants {
  color: #fdc2e5 !important;
}
.b-slider.is-refrigerants .b-tooltip.is-primary .tooltip-content {
  background: #fdc2e5;
}
.b-slider.is-refrigerants
  .b-tooltip.is-top.is-primary
  .tooltip-content::before {
  border-top-color: #fdc2e5 !important;
}
.switch.is-refrigerants input[type='checkbox']:checked + .check {
  background: #fdc2e5 !important;
}
.switch.is-refrigerants input[type='checkbox']:focus:checked + .check {
  -webkit-box-shadow: 0 0 0.5em rgba(253, 194, 229, 0.8) !important;
  box-shadow: 0 0 0.5em rgba(253, 194, 229, 0.8) !important;
}

.b-slider.is-vehicles .b-slider-fill {
  background: #fd8e62 !important;
}
.has-text-info.is-vehicles {
  color: #fd8e62 !important;
}
.b-slider.is-vehicles .b-tooltip.is-primary .tooltip-content {
  background: #fd8e62;
}
.b-slider.is-vehicles .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #fd8e62 !important;
}
.switch.is-vehicles input[type='checkbox']:checked + .check {
  background: #fd8e62 !important;
}
.switch.is-vehicles input[type='checkbox']:focus:checked + .check {
  -webkit-box-shadow: 0 0 0.5em rgba(253, 142, 98, 0.8) !important;
  box-shadow: 0 0 0.5em rgba(253, 142, 98, 0.8) !important;
}

.b-slider.is-travels .b-slider-fill {
  background: #67c3a5 !important;
}
.has-text-info.is-travels {
  color: #67c3a5 !important;
}
.b-slider.is-travels .b-tooltip.is-primary .tooltip-content {
  background: #67c3a5;
}
.b-slider.is-travels .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #67c3a5 !important;
}
.switch.is-travels input[type='checkbox']:checked + .check {
  background: #67c3a5 !important;
}
.switch.is-travels input[type='checkbox']:focus:checked + .check {
  -webkit-box-shadow: 0 0 0.5em rgba(90, 171, 144, 0.8) !important;
  box-shadow: 0 0 0.5em rgba(90, 171, 144, 0.8) !important;
}

.b-slider.is-commutes .b-slider-fill {
  background: #8ea0cc !important;
}
.has-text-info.is-commutes {
  color: #8ea0cc !important;
}
.b-slider.is-commutes .b-tooltip.is-primary .tooltip-content {
  background: #8ea0cc;
}
.b-slider.is-commutes .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #8ea0cc !important;
}
.switch.is-commutes input[type='checkbox']:checked + .check {
  background: #8ea0cc !important;
}
.switch.is-commutes input[type='checkbox']:focus:checked + .check {
  -webkit-box-shadow: 0 0 0.5em rgba(142, 160, 204, 0.8) !important;
  box-shadow: 0 0 0.5em rgba(142, 160, 204, 0.8) !important;
}

.b-slider.is-foods .b-slider-fill {
  background: #e5c896 !important;
}
.has-text-info.is-foods {
  color: #e5c896 !important;
}
.b-slider.is-foods .b-tooltip.is-primary .tooltip-content {
  background: #e5c896;
}
.b-slider.is-foods .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #e5c896 !important;
}
.switch.is-foods input[type='checkbox']:checked + .check {
  background: #e5c896 !important;
}

.b-slider.is-devices .b-slider-fill {
  background: #a6d953 !important;
}
.has-text-info.is-devices {
  color: #a6d953 !important;
}
.b-slider.is-devices .b-tooltip.is-primary .tooltip-content {
  background: #a6d953;
}
.b-slider.is-devices .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #a6d953 !important;
}
.switch.is-devices input[type='checkbox']:checked + .check {
  background: #a6d953 !important;
}
.switch.is-devices input[type='checkbox']:focus:checked + .check {
  -webkit-box-shadow: 0 0 0.5em rgba(166, 217, 83, 0.8) !important;
  box-shadow: 0 0 0.5em rgba(166, 217, 83, 0.8) !important;
}

.b-slider.is-purchases .b-slider-fill {
  background: #ffda2c !important;
}
.has-text-info.is-purchases {
  color: #ffda2c !important;
}
.b-slider.is-purchases .b-tooltip.is-primary .tooltip-content {
  background: #ffda2c;
}
.b-slider.is-purchases .b-tooltip.is-top.is-primary .tooltip-content::before {
  border-top-color: #ffda2c !important;
}
.switch.is-purchases input[type='checkbox']:checked + .check {
  background: #ffda2c !important;
}
.switch.is-purchases input[type='checkbox']:focus:checked + .check {
  -webkit-box-shadow: 0 0 0.5em rgba(255, 218, 44, 0.8) !important;
  box-shadow: 0 0 0.5em rgba(255, 218, 44, 0.8) !important;
}
</style>
